// routes
import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

// config-navigation.js

export function getNavConfigDesktop(headerData) {
  return [
    {
      title: 'About Us',
      path: paths.about,
    },
    {
      title: 'Our Projects',
      path: paths.ourProject,
      children: [
        {
          mainTitle: 'Our Projects',
          mainSubtitle: 'From vision to reality, we shape homes that inspire',
          items: [
            {
              title: 'Upcoming Projects',
              subtitle: 'Discover our upcoming developments and future plans',
              path: paths.ourProjectUpcoming,
              image: `${process.env.REACT_APP_HOST_API}${headerData?.Upcoming?.url}`,
            },
            {
              title: 'Ongoing Projects',
              subtitle: 'Explore our current developments in progress',
              path: paths.ourProjectOngoing,
              image: `${process.env.REACT_APP_HOST_API}${headerData?.Ongoing?.url}`,
            },
            {
              title: 'Completed Projects',
              subtitle: 'View our successfully delivered projects',
              path: paths.ourProjectCompleted,
              image: `${process.env.REACT_APP_HOST_API}${headerData?.Completed?.url}`,
            },
          ],
        },
      ],
    },
    {
      title: 'Investors Lounge',
      path: paths.investorLounge,
    },
  ];
}

export function getNavConfigMobile(headerData) {
  return [
    {
      title: 'About Us',
      // icon: <Iconify // icon="solar:home-2-bold-duotone" />,
      path: paths.about,
    },
    {
      title: 'Our Projects',
      // path: paths.ourProject,
      path: paths.ourProject,
      // icon: <Iconify // icon="solar:file-bold-duotone" />,
      children: [
        {
          items: [
            {
              title: 'Upcoming',
              // path: paths.ourProjectUpcoming,
              path: paths.ourProjectUpcoming,
              image: `${process.env.REACT_APP_HOST_API}${headerData?.UpcomingMobile?.url}`,
            },
            {
              title: 'Ongoing',
              // path: paths.ourProjectOngoing,
              path: paths.ourProjectOngoing,
              image: `${process.env.REACT_APP_HOST_API}${headerData?.OngoingMobile?.url}`,
            },
            {
              title: 'Completed',
              // path: paths.ourProjectCompleted,
              path: paths.ourProjectCompleted,
              image: `${process.env.REACT_APP_HOST_API}${headerData?.CompletedMobile?.url}`,
            },
          ],
        },
      ],
    },
    {
      title: 'Investors Lounge',
      // icon: <Iconify // icon="solar:notebook-bold-duotone" />,
      // path: paths.investorLounge,
      path: paths.investorLounge,
    },
    {
      title: 'CSR',
      // icon: <Iconify // icon="solar:notebook-bold-duotone" />,
      // path: paths.csr,
      path: paths.csr,
    },
    {
      title: 'Newsroom',
      // icon: <Iconify // icon="solar:notebook-bold-duotone" />,
      // path: '/post',
      path: paths.newsroom,
    },
    {
      title: 'Careers',
      // icon: <Iconify icon="solar:notebook-bold-duotone" />,
      path: paths.career,
    },
  ];
}
